import React from 'react';
import type { Surgeon } from '../data/constants.js';
import { C } from '../data/constants.js';

interface LeaderboardRowProps {
  surgeon: Surgeon;
  rank: number;
  metric: string;
  metricLabel: string;
  metricColor: string;
  delay: number;
}

const medals: Record<number, string> = { 1: '\u{1F947}', 2: '\u{1F948}', 3: '\u{1F949}' };

export function LeaderboardRow({
  surgeon,
  rank,
  metric,
  metricLabel,
  metricColor,
  delay,
}: LeaderboardRowProps): React.ReactElement {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        padding: '14px 18px',
        borderBottom: `1px solid ${C.cardBorder}`,
        animation: `insights-fadeSlideUp 0.4s ease ${delay}ms both`,
        transition: 'background 0.15s',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(0,207,160,0.02)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'transparent';
      }}
    >
      <span
        style={{
          fontSize: rank <= 3 ? 20 : 14,
          width: 32,
          textAlign: 'center',
          fontFamily: "'Space Mono', monospace",
          color: rank <= 3 ? 'inherit' : C.textFaint,
          fontWeight: 700,
        }}
      >
        {medals[rank] || `#${rank}`}
      </span>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#fff' }}>{surgeon.name}</div>
        <div style={{ fontSize: 11, color: C.textDim, marginTop: 2 }}>
          {surgeon.specialty} &middot; {surgeon.procedures} cases
        </div>
      </div>
      <div style={{ textAlign: 'right' }}>
        <div
          style={{
            fontSize: 18,
            fontWeight: 700,
            color: metricColor,
            fontFamily: "'Space Mono', monospace",
          }}
        >
          {metric}
        </div>
        <div style={{ fontSize: 10, color: C.textDim }}>{metricLabel}</div>
      </div>
      {surgeon.adoptionRate != null && (
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: 10,
            background: `${metricColor}10`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              width: `${Math.min(surgeon.adoptionRate, 100)}%`,
              maxWidth: 28,
              height: 4,
              borderRadius: 2,
              background: metricColor,
            }}
          />
        </div>
      )}
    </div>
  );
}
